import * as React from "react"
import Autocomplete from "@mui/material/Autocomplete"
import { CircularProgress, ListItem, ListItemText, TextField } from "@mui/material";
//import { Organization } from "../models/Organization";

interface CompanySearchProps {
    onSelectCompany: (companyName?: {name: string, organizationNumber: string}/*Organization*/) => void;
    clearOnSelect: boolean;
}

const CompanySearch: React.FC<CompanySearchProps> = (props) => {
    const [value, setValue] = React.useState<BrregOrganization | null>(null);
    const [searchIsOpen, setSearchIsOpen] = React.useState(false);
    const [options, setOptions] = React.useState<readonly BrregOrganization[]>([]);
    const loading = searchIsOpen && options.length === 0;
    const [inputValue, setInputValue] = React.useState("")

    const mapToBrregOrg = (json: any): BrregOrganization => ({
        name: json.navn,
        numberOfEmployees: json.antallAnsatte,
        businessAddress: {
            country: json.forretningsadresse?.land ?? "",
            countrycode: json.forretningsadresse?.landkode ?? "",
            zipCode: json.forretningsadresse?.postnummer ?? "",
            city: json.forretningsadresse?.poststed ?? ""
        },
        bankrupt: json.konkurs,
        language: json.maalform,
        organizationNumber: json.organisasjonsnummer,
        dateOfIncorporation: json.stiftelsesdato
    })

    const mapToOrganization = (value: BrregOrganization | string): {name: string, organizationNumber: string}/*Organization*/ => {
        const brregOrg: BrregOrganization | null = typeof value !== "string" && value ? value as BrregOrganization : null
        return {
            name: brregOrg?.name ?? value as string,
            organizationNumber: brregOrg?.organizationNumber ?? ""
        }
    }

    React.useEffect(() => {
        if (inputValue === undefined || inputValue === "") {
            setOptions([])
            return
        }
        const regex = /^\d{9}$/
        if (regex.test(inputValue.replaceAll(" ", ""))) {
            (async () => {
                const orgsResponse = await fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${inputValue.replaceAll(" ", "")}`)
                const json = await orgsResponse.json()
                const unit = mapToBrregOrg(json)
                console.log("SETTER ENEHTER")
                console.log([unit])
                setOptions([unit, {...unit, name: "dsfsdfs as", organizationNumber: "sdfsdfdsfsd"}])
            })();
        } else {
            (async () => {
                const orgsResponse = await fetch(`https://data.brreg.no/enhetsregisteret/api/enheter?navn=${inputValue}`)
                const json = await orgsResponse.json()
                const units = json?._embedded?.enheter?.map((it: any) => mapToBrregOrg(it)) ?? []
                console.log("SETTER ENHETER")
                console.log(units)
                setOptions(old => units)
            })();
        }
    }, [inputValue])

    const handleInputChange = (_event: React.SyntheticEvent<Element, Event>, newInputValue: string) => {
        console.log("T " + newInputValue)
        setInputValue(newInputValue)
    }

    console.info("What is value", options)
    return (
        <Autocomplete
            key={value ? "true" : "false"}
            id="company-search-field"
            open={searchIsOpen}
            noOptionsText="Ingen treff"
            onOpen={() => {
                setSearchIsOpen(true)
            }}
            onClose={() => {
                setSearchIsOpen(false)
            }}
            inputValue={inputValue}
            isOptionEqualToValue={(option: BrregOrganization, value) => {
                console.log("Equality check: ", option.organizationNumber === value.organizationNumber)
                return option.organizationNumber === value.organizationNumber
            }}
            getOptionLabel={(option) => {
                console.info("DID THIS TART IT!", option.name)
                return `${option.name}`
            }}
            options={options}
            loading={loading}
            value={value}
            onChange={(_: any, newValue: BrregOrganization | null) => {
              //setOptions(newValue ? [newValue, ...options] : options);
              console.log("SJEER DET NOKKA HÆR??")
              props.onSelectCompany(newValue !== null ? mapToOrganization(newValue) : undefined)
              //setValue(newValue);
              if (props.clearOnSelect) {
                console.log("TEst clear")
                setValue(null);
                setInputValue("")
              }
            }}
            onInputChange={handleInputChange}
            renderOption={(props, option) => {
               console.info("RENDERING OPTIONS", option) 
                return (
                <ListItem {...props} key={option.name} >
                    <ListItemText primary={option.name} secondary={option.organizationNumber} />
                </ListItem>
            )}}
            renderInput={(params) => {
                console.log("RENDER INPUT")
                return (<TextField
                    {...params}
                    label="Søk etter firma"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null }
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        )
                    }}
                />)
            }}
        />
    )
}

interface BrregAddress {
    country: string,
    countrycode: string,
    zipCode: string,
    city: string,
}

interface BrregOrganization {
    name: string,
    numberOfEmployees: number,
    businessAddress: BrregAddress,
    bankrupt: boolean,
    language: string,
    organizationNumber: string,
    dateOfIncorporation: string
}

export default CompanySearch;